import { notification } from 'antd'
import { ArgsProps } from 'antd/lib/notification'
import { CheckCircleIcon, CircleXIcon, CircleAlertIcon, InfoIcon } from 'lucide-react'

type NotificationProps = ArgsProps

const openSuccessNotification = (config: NotificationProps): void => {
  notification.success({
    ...config,
    icon: <CheckCircleIcon className='success-icon' />,
    className: 'bg-success flex items-center',
  })
}

const openInfoNotification = (config: NotificationProps): void => {
  notification.info({
    ...config,
    icon: <InfoIcon />,
    className: 'bg-info-border flex items-center',
  })
}

const openWarningNotification = (config: NotificationProps): void => {
  notification.warning({
    ...config,
    icon: <CircleAlertIcon />,
    className: 'bg-warning flex items-center',
  })
}

const openErrorNotification = (config: NotificationProps): void => {
  notification.error({
    ...config,
    icon: <CircleXIcon />,
    className: 'bg-error flex items-center',
  })
}

export const notificationController = {
  success: openSuccessNotification,
  info: openInfoNotification,
  warning: openWarningNotification,
  error: openErrorNotification,
}
